import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { colors, types } from "../../../../libs";

export const ActivityModal = styled(Modal)`
  .modal-dialog {
    max-width: 760px;
  }
  .modal-content {
    background: transparent;
    border: 0;
  }
`;
export const ModalWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: ${colors.background.lightBlack};
  border-radius: 8px;
  max-height: 88vh;
  overflow-y: auto;
  scrollbar-color: ${colors.background.darkGreen} transparent;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${colors.background.darkGreen};
    border-radius: 10px;
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
`;
export const ModalTitle = styled.div`
  ${types.body.secondaryTitle};
  color: ${colors.text.white};
  font-weight: bold;
`;
export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 5px;
`;
export const CloseButton = styled.button`
  border: 0;
  background: transparent;
  color: ${colors.text.gray};
  display: flex;
  padding: 4px;
  &:hover {
    color: ${colors.text.white};
  }
`;
export const Message = styled.div`
  ${types.body.normal};
  color: ${colors.text.gray};
  text-align: center;
  padding: 44px 12px;
`;
export const ErrorMessage = styled(Message)`
  color: ${colors.text.red};
`;
export const RegistrationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
export const RegistrationCard = styled.div`
  padding: 16px;
  border-radius: 8px;
  background: ${colors.background.formField};
  border: 1px solid rgba(255, 255, 255, 0.07);
`;
export const MemberHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  @media (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;
export const MemberIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
`;
export const Avatar = styled.div`
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.background.lightGrey};
  color: ${colors.text.green};
`;
export const MemberName = styled.div`
  ${types.body.normal};
  color: ${colors.text.white};
  font-weight: 600;
`;
export const MemberEmail = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 2px;
`;
export const RegisteredAt = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  white-space: nowrap;
`;
export const LandingUrl = styled.div`
  ${types.body.small};
  color: ${colors.text.disabled};
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 12px 0;
  overflow-wrap: anywhere;
`;
export const PurchaseHeader = styled.div`
  ${types.body.normal};
  color: ${colors.text.white};
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 14px;
  padding-top: 13px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-weight: 600;
`;
export const CountBadge = styled.span`
  ${types.body.small};
  color: ${colors.text.green};
  background: ${colors.background.lightGrey};
  padding: 2px 7px;
  border-radius: 10px;
`;
export const PurchaseList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;
export const PurchaseRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  & + & {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }
`;
export const PurchaseIcon = styled.div`
  color: ${colors.text.green};
  display: flex;
`;
export const PurchaseCopy = styled.div`
  flex: 1;
  min-width: 0;
`;
export const PurchaseName = styled.div`
  ${types.body.normal};
  color: ${colors.text.white};
`;
export const PurchaseDate = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 2px;
`;
export const PurchasePrice = styled.div`
  ${types.body.normal};
  color: ${colors.text.green};
  font-weight: 600;
  white-space: nowrap;
`;
export const NoPurchases = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  padding-top: 10px;
`;
